import React, { useState, useEffect } from 'react';
import { makeStyles, createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';


let HorizontalLabelPositionBelowStepper = (props) => {
  const getColorByAge = (age, activeStepProps) => {
    if (age === undefined) return '#545cd8'
    else if (age >= 0 && age < activeStepProps.midAge) return '#3ac47d'
    else if (age >= activeStepProps.midAge && age < activeStepProps.maxAge) return '#f7b924'
    else return '#d92550'
  }

  const muiTheme = createMuiTheme({
    overrides: {
      MuiStepIcon: {
        root: {
          '&$active': {
            color: getColorByAge(props.activeStepAge, props.pasoActivo),
          },
          '&$completed': {
            color: '#545cd8',
          },
        },
      },
    }
  });

  const useStyles = makeStyles((theme) => ({
    root: {
      width: '100%',
    },
    backButton: {
      marginRight: theme.spacing(1),
    },
    instructions: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
  }));

  const classes = useStyles();
  const [activeStep, setActiveStep] = useState(0);
  const steps = props.steps;

  useEffect(() => {
    if (props.activeStep !== undefined) {
      setActiveStep(props.activeStep)
    }
  }, [props])

  return (
    <div className={classes.root} style={{ overflowX: 'auto' }}>
      <MuiThemeProvider theme={muiTheme}>
        <Stepper activeStep={activeStep} alternativeLabel>
          {steps.map((label, index) => {
            return (
              <Step key={`${label}${index}`}>
                <StepLabel>
                  {label}
                </StepLabel>
              </Step>
            )
          })}
        </Stepper>
      </MuiThemeProvider>
    </div>
  );
}

export default HorizontalLabelPositionBelowStepper;